import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faGoogle } from "@fortawesome/free-brands-svg-icons";

export const AccountSocialLogin = () => {
  const socialLogins = [
    {
      type: "facebook",
      icon: faFacebookF,
      color: "#4267B2",
    },
    {
      type: "google",
      icon: faGoogle,
      color: "#DB4A39",
    },
  ];

  return (
    <div className="flex justify-center gap-[15px] mt-3">
      {socialLogins.map((social) => (
        <a
          href={`https://social-login.oxiapps.com/auth/${social.type}?shop=${Shopify.shop}&parentUrl=${window.location.href}`}
          className="flex items-center justify-center rounded-lg flex-1 border border-brand-mid-grey h-[42px] hover:opacity-[0.8]"
          target="_blank"
        >
          <FontAwesomeIcon icon={social.icon} fontSize={18} style={{ color: social.color }} />
        </a>
      ))}
    </div>
  );
};
